

export const de = {
    common: {
        languageChanged: "Sprache geändert",

        yes: "Ja",
        no: "Nein",
        blocked: "Blockiert",
        save: "Speichern",
        delete:"Löschen",
        filter: {
            apply: "Übernehmen",
            clear: "Filter zurücksetzen",
        },

        pagination: {
            rowsPerPage: "Zeilen pro Seite",
        },

        opened: "Offen",
        closed: "Geschlossen",


        signOut: "Abmelden",
        active: "Aktiv",
        notActive: "Inaktiv",
        notAvailable: "nicht verfügbar",
        valuesNotAvailable: "-",
        navItem: {
            home: "Home",
            dashboard: "Dashboard",
            devices: "Geräte",
            contact: "Kontakt",
        },
        welcome: "Willkommen in Ihrer Monitoring-Cloud",
        definition: "Das smarte Dashboard für Ihre Batteriespeicher",
        toDashboard: "zum Dashboard",

               
        /*
        nowarning: "Normal",
        warning: "Warnung aktiv",

        noalarm: "Normal",
        alarm: "Alarm aktiv",


        ok: "Störungsfrei",        
        Triggered: "Störung",
        */
        warning: "Warnung",
        ok: "Okay",
        alarm: "Alarm",
        Triggered: "Ausgelöst",
    },
    navbar: {
        usermanagement: "Benutzerverwaltung",
        clients: "Mandanten",
        locations: "Standorte", 
        dashboards: "",
        overview: "Gesamt-Übersicht",
        devices: "Geräte",
        devicesGroups: "Gerätegruppen",
        topicMetrics: "Abrechnung-Topics",
        device: {
            main: "Geräte",
            primaryData: "Stammdaten",
            battery: "Batterie",
            inverter: "Wechselrichter",
            connections: "Externe Anbindungen",
            auxData: "Nebenantriebe",
            sld: "Single Line Diagram",
            control:"Regler",
            wallbox: "Wallbox",
            overview: "Übersicht",
            events: "Ereignisse",
            settings: "Einstellungen",
            information: "Informationen",
        },
        cases: "Störmeldungen",
        operations: "Einsatzberichte",
        reports: {
            main: "Berichte",
            monthlyReports: "Monatsberichte",
        },
        favorites:"Favoriten",
        general: "Allgemein",
        user: {
            main: "Benutzer",
            account: "Benutzerkonto",
            notifications: "Benachrichtigungen",
        },
    },
    translations: {
        content:
            "Diese Nachricht wird von einer React-Komponente gerendert und zeigt interaktive Elemente und dynamische Aktualisierungen ohne vollständiges Neuladen der Seite.",
    },
    pages: {
        userManagement: {
            title: "Benutzerverwaltung",
            userName: "Name",
            email: "E-Mail Adrese",
            role: "Rollen",
            cleint: "Mandant",
            device: "Geräte",
            add: "Neuer Benutzer",
            blocked: "Blockiert",
            state: "Status",
            filter: {
                name: "Name",
                isBlocked: "nur blockierte Benutzer anzeigen",
                cleint: "Mandant",
                searchClient: "Mandant suchen...",
                userName: "Benutzername",
                ascending:"Aufsteigend",
                descending:"Absteigend"
            },
            noItemsFound: "keine Ergebnisse",
            newUser: {
                title: "Neuer Benutzer anlegen",
                newTitle: "Neuer Benutzer anlegen",
                updateTitle: "Benutzer bearbeiten",
                name: "Name",
                fullName:"Vollständiger Name",
                email: "E-Mail",
                password: "Passwort",
                passwordGeneration: "Passwort erstellen",
                passwordHide: "Aus",
                passwordShow:"Ein",
                userName: "Benutzername",
                theme: "Thema",
                dark: "Dunkel",
                light:"Hell",
                language: "Sprache",
                german: "Deutsch",
                english: "Englisch",
                client: "Mandant",
                searchClient:"Mandant suchen...",
                role: "Rolle",
                levelRole: "Stufe Rolle",
                selectRole:"Rolle auswählen",
                features: "Features",
                blocked:" Blockiert",
                auth0ID:"AuthoID",
                lastLogin: "Letzte Anmeldung",
                created:"Erstellungsdatum",
                loginCount:"Anmeldeanzahl",
                lastIP:"letzte IP-Adresse",
                emailVerified:"E-Mail bestätigt",

            },
            details: {
                validation: {
                    name: "Es wurde kein Name angegeben.",
                    email: "Ungültige E-Mail-Adresse",
                    userName:"Es wurde kein Benutzername angegeben.",
                    role: "Es wurde keine gültige Rolle ausgewählt.",
                    mandantId: "Es wurde keine gültiges Mandant ausgewählt.",
                    password: "Das Passwort muss mindestens 8 Zeichen lang sein.",
                },
                newButton: "Benutzer anlegen",
                updateButton: "Speichern",
            },
            messages: {
                userUpdated: "Benutzer erfolgreich aktualisiert",
                userCreated: "Benutzer erfolgreich angelegt",
                userCreatedError: "Benutzer konnte nicht erstellt werden.",
                saveFailed:"Etwas ist beim Speichern schief gelaufen,"
            }
        },
        clients: {
            title: "Mandanten",
            clientName:"Mandantenname",
            noItemsFound: "Keine Mandanten gefunden",
            filter: {
                client: "Mandantenname",
                searchClient: "Mandant suchen...",
                ascending: "Aufsteigend",
                descending:"Absteigend"
            }
        },
        locations: {
            createLocation:"Neuen Ort anlegen",
            title: "Standorte",
            city: "Stadt",
            postCode: "Postleitzahl",
            countryCode: "Ländercode",
            line1: "Adresse",
            line2: "Adresse2",
            latitude: "Latitude (Dezimalgrad)",
            longitude: "Longitude (Dezimalgrad)",

            coords: "Koordinaten (Grad Minuten Sekunden)",
            coordsDefaultText: "Geben Sie die Koordinaten im Google-Maps-Format ein, z. B.:52°34'57.5\"N 13°27'41.1\"E",



            addLocation: "Neuer Ort ",
            updateLocation: "Ort bearbeiten",

            createError:"Ort konnte nicht erstellt werden.",
            createSuccess: "Ort wurde erfolgreich erstellt.",

            updateSuccess:"Ort wurde erfolgreich aktualisiert.",
            updateError: "Ort konnte nicht aktualisiert werden.",

            deleteSuccess: "Ort wurde erfolgreich gelöscht.",
            deleteError:"Ort konnte nicht gelöscht werden.",

            newButton: "Ort anlegen",
            updateButton:"Speichern",
            filter: {
                search: "Suche",
                postCode: "Postleitzahl",
                countryCode: "Ländercode",
                sortBy: {
                    city: "Stadt",
                    postCode: "Postleitzahl",
                    countryCode: "Ländercode",
                },
                sorting: {
                    asc: "Aufsteigend",
                    dsc:"Absteigend",
                },
            },
            validation: {
                city: "Es wurde kein Stadtname angegeben.",
                countryCodeRequired: "Es wurde kein Ländercode angegeben.",
                countryCodeMax: "Max 2 zeichen!",
                line1: "Es wurde keine Adresse angegeben.",
                latitudeMin: "Gültige Werte von -90",
                latitudeMax: "Gültige Werte bis 90",
                postCodeRequired:"Es wurde keine Postleitzahl angegeben.",
                postCodeMax: "Max 5 zeichen!",
                latitudeRequired: "Es wurde keine latitude angegeben.",
                longitudeRequired:"Es wurde keine longitude angegeben."
            }
        },
        managementDevices: {
            title:"Geräte",
            commonName: "Name",
            docIdPrefix: "Prefix",
           
            datasourceId: "ID",
            locationName: "Standort",
            manufacturerName: "Hersteller",
            primaryCompanyName: "Betreiber",
            serialnumber: "Seriennummer",
            countChargers: "Ladepunkte",
            ratedPower: "Leistung",
            capacity: "Kapzität",
            isArchived:"Archiviert",
            isDeleted: "Gelöscht",
            status:"Status",
            noItemsFound: "keine Geräte gefunden",
            newButton:"Neues Gerät anlegen",
            filter: {
                search:"Suche",
                manufacture: "Hersteller",
                isDeleted: "Gelöscht",
                isArchived: "Archiviert",
                deviceType: "Gerätetypen",
                primaryCompany:"Betreiber",
                locations: "Standorte",
                type: "Type",
                Name: "Name",
                power: "Leistung",
                charger: "Ladepunkte",
                capacity: "Kapazität",
                ascending: "Aufsteigend",
                descending:"Absteigend"
            },
            newDevice: {
                addDevice: "Neues Gerät",
                updateDevice:"Gerät bearbeiten",
                commonName: "Allgemeiner Name",
                displayName: "Anzeigename",
                locations: "Standort",
                manufacturer: "Hersteller",
                primaryCompany: "Betreiber",
                deviceType: "Gerätetyp",
                datasourceId: "Datenquellen-ID",
                docIdPrefix: "Prefix",
                dateOfInstallation: "Installationsdatum",
                mfgsSerialNumber: "Seriennummer",
                countChargers: "Ladepunkte",
                ratedPower: "Leistung",
                capacity: "Kapzität",
                newButton: "Gerät anlegen",
                updateButton: "Speichern",

                createError: "Gerät konnte nicht erstellt werden.",
                createSuccess: "Gerät wurde erfolgreich erstellt.",

                updateError: "Gerät konnte nicht aktualisiert werden.",
                updateSuccess: "Gerät wurde erfolgreich aktualisiert.",

                deleteError: "Gerät konnte nicht gelöscht werden.",
                deleteSuccess: "Gerät wurde erfolgreich gelöscht.",

                dataSourceIdExists:"Datenquellen-ID existiert bereits"

            },
            validation: {
                commonName: "Es wurde kein Allgemeiner Name angegeben.",
                deviceType: "Es wurde kein Gerätetyp ausgewählt.",
                displayName: "Es wurde kein Anzeigename angegeben.",
                locations: "Es wurde kein Standort ausgewählt.",
                manufacturer: "Es wurde kein Hersteller ausgewählt.",
                primaryCompany: "Es wurde kein Betreiber ausgewählt.",
                datasourceId: "Es wurde kein ID angegeben.",
                docIdPrefix: "Es wurde kein Prefix angegeben.",
                docIdPrefixMax:"Max 6 zeichen!",
                mfgsSerialNumber: "Es wurde kein Seriennummer angegeben.",
                countChargers: "Es wurde keine gültige Ladepunkte angegeben.",
                ratedPower: "Es wurde keine Leistung angegeben.",
                capacity: "Es wurde kein Kapzität angegeben.",
                dateOfInstallation: "Es wurde kein Installationsdatum angegeben.",
            }

        },
        devicesGroup: {
            title: "Gerätegruppen",
            commonName:"Gruppenname",
            displayName: "Name",
            groupType: "Gruppentyp",
            groupMandant: "Mandant",
            groupVerbund: "Verbundsystem",
            groupEMail: "E-Mail",
            groupNone: "Nichts",
            groupAdmin: "Administrator",
            groupLocation: "Standort",
            isDeleted: "Status",
            assignedPrimaryDevice:"Primärgerät",
            assignedDevices: "Geräte",
            assignedDevice: "Gerät",
            assignedUsers: "Benutzer",
            newButton: "Neue Gruppe anlegen",
            noItemsFound:"keine Gruppen gefunden",
           
            newGroup: {
                title: "",
                addGroup: "Neue Gruppe ",
                updateGroup:"Gruppe bearbeiten",
                commonName: "Gruppenname",
                displayName: "Anzeigename",
                groupType: "Gruppentyp",
                admin: "Gruppenadministrator",
                assignedPrimaryDevice: "Primärgerät",
                assignedPrimaryDeviceType:"Primärgerättyp",
                selectAdmin: "Gruppenadministrator auswählen",

                selectAssignedPrimaryDevice:"Primärgerät auswählen",
                assignedDevices: "Geräte",
                selectAssignedDevices: "Geräte auswählen",
                assignedUsers: "Benutzer",
                selectAssignedUsers: "Benutzer auswählen",
                client:"Mandant",
                selectClient: "Mandant auswählen",
                newButton: "Gruppe anlegen",
                updateButton: "Speichern",
                createError: "Gruppe konnte nicht erstellt werden.",
                createSuccess: "Gruppe wurde erfolgreich erstellt.",
                updateError: "Gruppe konnte nicht aktualisiert werden.",
                updateSuccess: "Gruppe wurde erfolgreich aktualisiert.",
                deleteError:"Gruppe konnte nicht gelöscht werden.",
                deleteSuccess:"Gruppe wurde erfolgreich gelöscht.",
                selectGroupType: "Gruppentyp auswählen",
            },
            filter: {
                search:"Suche",
                groupType:"Gruppentyp",
                searchGroupType:"Gruppentyp suchen...",
                isDeleted: "Gelöscht",
                groupMandant:"Mandant",
                groupLocation:"Standort",
                name: "Gruppenname",
                ascending: "Aufsteigend",
                descending: "Absteigend",
                users:"Benutzer"
            },
            validation: {
                groupType: "Es wurde kein Gruppentyp ausgewählt.",
                commonName: "Es wurde kein allgemeiner Name angegeben.",
                displayName: "Es wurde kein Anzeigename angegeben.",
                mandant: "Es wurde kein Mandant ausgewählt.",
                admin: "Es wurde kein Gruppenadministrator ausgewählt.",
                assignedUsers: "",
                assignedPrimaryDevice:"Es wurde kein Primärgerät ausgewählt."

            },
        },
        overview: {
            title: "Gesamt-Übersicht",

            kpiOnline1: "{{current}} von {{max}}",
            kpiOnline2: "Geräte Online",
            kpiTotalCapacity: "Kapazität",
            kpiTotalPower: "Leistung",
            kpiUnloadTotalPower: "Entladeleistung",
            kpiLoadTotalPower: "Ladeleistung",
            /*kpiTotalPower: "Leistung",*/
            kpiAverageSoC: "SoC",

            kpiEnergyImportConsumptionTotalTitle: "Energiemenge",
            kpiEnergyImportConsumptionTotal: "importierte Energiemenge",
            kpiEnergyExportConsumptionTotal: "exportierte Energiemenge",

            kpiEnergyImportConsumptionMonthlyTitle: "Energiemenge (Monat)",
            kpiEnergyImportConsumptionMonthly: "importierte Energiemenge (aktueller Monat)",
            kpiEnergyExportConsumptionMonthly: "exportierte Energiemenge (aktueller Monat)",

            help: {

                onlineDevices: "Für die Berechnung werden nur Geräte berücksichtigt, die online sind.",


                "powerDescription": "Dieses Feld zeigt die aktuelle Lade- und Entladeleistung aller Geräte, die derzeit online sind.\n\nLinke Seite (0 kW): Hier wird die gesamte Entladeleistung angezeigt.\nDas bedeutet: Energie wird von Geräten abgegeben.\n\nRechte Seite (z. B. 130 kW): Hier wird die gesamte Ladeleistung angezeigt.\nDas bedeutet: Energie wird von Geräten aufgenommen.\n\nDie angezeigten Werte sind die Summe der Lade- bzw. Entladeleistung aller aktuell online befindlichen Geräte.\n\nGeräte, die offline sind (also keine aktive Verbindung haben), können nicht berücksichtigt werden und fließen daher nicht in die Berechnung ein.\n\nSo erhalten Sie auf einen Blick eine klare Übersicht darüber, wie viel Leistung gerade geladen bzw. entladen wird.",

                "energyTotalDescription": "Dieses Feld zeigt die gesamte Energiemenge, die alle aktuell online befindlichen Geräte über den gesamten Zeitraum aufgenommen oder abgegeben haben.\n\nLinke Seite – Exportierte Energie: Energie, die insgesamt an die angeschlossenen Verbraucher (z. B. Gebäude oder Supermarkt) abgegeben wurde.\nRechte Seite – Importierte Energie: Energie, die insgesamt in die Geräte geladen wurde.\n\nDie Messung erfolgt am Netzanschlusspunkt.\n\nEntsteht dort überschüssige Energie, zum Beispiel aus Solaranlagen oder Windkraftanlagen, wird diese Energie zum Laden der Geräte verwendet. Diese Energiemenge wird als importierte Energie dargestellt.\n\nWird mehr Energie benötigt als direkt verfügbar ist, geben die Geräte Energie an die angeschlossenen Verbraucher ab. Diese Energiemenge wird als exportierte Energie ausgewiesen.\n\nBerücksichtigt werden ausschließlich Geräte, die online sind. Offline-Geräte werden nicht einbezogen.",
                "energyMonthDescription": "Dieses Feld zeigt die Energiemenge, die alle aktuell online befindlichen Geräte im laufenden Monat aufgenommen oder abgegeben haben.\n\nLinke Seite – Exportierte Energie: Energie, die im aktuellen Monat an die angeschlossenen Verbraucher abgegeben wurde.\nRechte Seite – Importierte Energie: Energie, die im aktuellen Monat in die Geräte geladen wurde.\n\nDie Erfassung erfolgt am Netzanschlusspunkt.\n\nÜberschüssige Energie, die dort entsteht, zum Beispiel aus Solaranlagen oder Windkraftanlagen, wird zum Laden der Geräte genutzt. Diese Energiemenge wird als importierte Energie ausgewiesen.\n\nReicht die direkt verfügbare Energie nicht aus, geben die Geräte Energie an die angeschlossenen Verbraucher ab. Diese Energiemenge wird als exportierte Energie dargestellt.\n\nEs werden ausschließlich online befindliche Geräte berücksichtigt. Offline-Geräte fließen nicht in die Berechnung ein.",
                "socDescription": "Dieses Feld zeigt den durchschnittlichen Ladezustand (State of Charge, SOC) aller aktuell online befindlichen Geräte an.\n\nDer angezeigte Prozentwert gibt an, wie voll die Geräte im Durchschnitt geladen sind.\n\nEin Wert von 100 % bedeutet, dass alle berücksichtigten Geräte vollständig geladen sind. Ein niedrigerer Wert zeigt, dass die Geräte im Durchschnitt noch nicht vollständig geladen wurden.\n\nIn die Berechnung fließen ausschließlich Geräte ein, die online sind. Offline-Geräte werden nicht berücksichtigt.",



            }
        },
        devices: {
            title: "Geräte",

            details: {
                title: "Gerät",
                title2: "Übersicht",

                kpiSoC: "SoC",
                kpiSoH: "SoH",
                kpiTotalCapacity: "Kapazität",
                kpiTotalPower: "Leistung",

                kpiTotalPowerLoading: "Laden",
                kpiTotalPowerUnLoading: "Entladen",

                trend: {
                    title: "Daten",
                    internActivePower: "Geräteleistung",
                    interActivePowerWBS: "Eigenbedarf",
                    externActivePower: "Netzanschlusspunktleistung",
                    batteryTemperature: "Batterie Temperatur",
                },
            },
            primaryData: {
                general: "Allgemein",

                contact: "Kontakte",
            },
            general: {
                deviceId: "ID",
                deviceType: "Gerätetyp",
                manufactureName: "Hersteller",
                editButton: "Bearbeiten",
                canselButton: "Abbrechen",
                confirmButton: "Übernehmen",
                isSaving: "Speichern...",
                archived: "Archiviert",
                installationDate: "Installationsdatum",
                serialNumber: "Seriennummer",
                deviceLocation: "Gerätestandort",
                noCooordinates: "Es sind keine Koordinaten verfügbar.",
                failedtoSave: "",
                saved: "",
                commonName: "Allgemeiner Name",
                displayName: "Anzeigename",
                newDisplayName: "Neuer Anzeigename",
                failedLoading: "Das Laden der Allgemeinseite ist fehlgeschlagen.",
                displayNameUpdated: "Anzeigename erfolgreich bearbeitet.",
                noChanges: "Keine Änderungen",
                updateFailed: "Fehler bei der Bearbeitung",
                capacity: "Kapazität",
                countWallboxes: "Anzahl Ladepunkte",
                maxInverterPower: "Wechselrichterleistung",
                companyData: "Betriebsdaten",
                location: "Adresse",
                city: "Ort",
                line1: "Straße",
                postCode:"Postleitzahl"
            },
            contacts: {
                noAddress:"Keine Adresse",
                addresse: "Adresse",
                street: "Straße",
                postCode: "Postleitzahl",
                location: "Ort",
                country: "Land (Iso2Code)",
                firstName: "Name",
                companyName: "Firma",
                phone: "Telefon",
                manufacturer: "Hersteller",
                contactPerson: "Ansprechpartner",
                customer: "Kunde",
                displayName:"Anzeigename",
                email: "E-Mail",
                role: "Rolle",
                create: "neuen Kontakt anlegen",
                add:"Kontakt anlegen",
                update:"Kontakt bearbeiten",
                devices: "Geräte",
                city: "Stadt",
                addressAddition:"Adresszusatz",
                selectAssignedDevices: "Geräte auswählen",
                selectCompany: "Firma auswählen",
                selectRole: "Rolle auswählen",
                noItemsFound: "keine Kontakte gefunden",
                commonName: "Allgemeinname",
                companyDisplayName:"Anzeigename",

                details: {
                    validation: {
                        displayName: "Es wurde kein Anzeigename angegeben.",
                        email: "Es wurde keine gültige E-Mail-Adresse angegeben.",
                        phoneNumber: "Es wurde keine Telefonnummer angegeben.",
                        kindDisplayName: "Es wurde keine Rolle ausgewählt.",
                        kind: "Es wurde keine Rolle ausgewählt.",
                        company: "Es wurde keine Firma ausgewählt.",
                        devices: "Es wurde kein Gerät ausgewählt.",
                        street: "Es wurde kein Straßenname angegeben.",
                        postCode: "Es wurde keine Postleitzahl angegeben.(Max 5 zeichen!)",
                        city: "Es wurde kein Stadtname angegeben.",
                        country: "Es wurde kein Ländercode angegeben.(Max 2 zeichen!)",
                        companyCommonName:"Es wurde kein Allgemeinname angegeben.",
                        companyDisplayName:"Es wurde kein Anzeigename angegeben."
                    }
                }
            },
            battery: {
                title: "Batterie",

                kpiSoC: "SoC",
                kpiSoH: "SoH",
                kpiTotalPower: "Leistung",
                kpiStrings1: "{{current}} von {{max}}",
                kpiStrings2: "Batterie-Module verbunden",

                states: {
                    loading: "laden",
                    unloading: "entladen",
                },

                trend: {
                    power: "Leistung",
                    cellMaxTemperatur: "Temperatur",
                    cellMinVoltage: "minimale Zellspannung",
                    cellMaxVoltage: "maximale Zellspannung",
                },
            },
            wallbox: {
                title: "Wallbox",

                power: "Aktuelle Ladeleistung",
                status: "Wallbox Status",
                vehicleStatus: "Fahrzeug Status",
            },
            inverter: {
                title: "Wechselrichter",

                installedPower: "installierte Leistung",
                installedInverters: "installierte Wechselrichter",
                activeInverters: "aktive Wechselrichter",

                inverters1: "{{current}} von {{max}}",
                inverters2: "Wechselrichter",

                statesDefinition: {
                    Init: "(0) System is starting",
                    Standby: "(1) Power is off, system waits a request",
                    PowerOn: "(2) System ready to start",
                    Charge: "(3) Charge on going",
                    SafeD: "(4) Critical fault occurred; system halted in this mode until user action.",
                    Reserved: "(5) Reserved",
                    Stopping: "(6) Converter is stopping and power is being killed off",
                    LockDSP: "(7) The state machine waits for DCDC to be in Standby mode",
                    FaultAck: "(8) Fault acknowledgement",
                },
                states: {
                    Init: "(0) Init",
                    Standby: "(1) Standby",
                    PowerOn: "(2) PowerOn",
                    Charge: "(3) Charge",
                    SafeD: "(4) SafeD",
                    Reserved: "(5) Reserved",
                    Stopping: "(6) Stopping",
                    LockDSP: "(7) LockDSP",
                    FaultAck: "(8) FaultAck",
                },
                operationModes: {
                    Invalid: "(-1) Invalid",
                    Unknown: "(0) Operation mode is not specified, system remains in stand by state",
                    VSI: "(1) Voltage source inverter (VSI) mode for V2L operation",
                    PFCpower: "(2) P/Q Mode",
                    PFCvoltage: "(3) U/F Mode",
                },
                errorcode: {},
                faultWords: {
                    empty: "-",
                    value0: "(0) Over-current protection on phase L1",
                    value1: "(1) Over-current protection on phase L2",
                    value2: "(2) Over-current protection on phase L3",
                    value3: "(3) Over-current protection on phase L4",
                    value4: "(4) Over-voltage protection on phase L1",
                    value5: "(5) Over-voltage protection on phase L2",
                    value6: "(6) Over-voltage protection on phase L3",
                    value7: "(7) Over-voltage protection on phase L4",
                    value8: "(8) Over-frequency protection",
                    value9: "(9) Under-frequency protection",
                    value10: "(10) Anti-Islanding protection",
                    value11: "(11) Over-voltage protection on DC-link Bus",
                    value12: "(12) Over-voltage protection on battery",
                    value13: "(13) Under-voltage protection on battery",
                    value14: "(14) Over-current protection on battery",
                    value15: "(15) Thermal shutdown on DCDC grid side mosfets",
                    value16: "(16) Thermal shutdown on DCDC battery side mosfets",
                    value17: "(17) Thermal shutdown on PFC mosfets",
                    value18: "(18) Thermal shutdown on DCDC transformer",
                    value19: "(19) Thermal shutdown on ambient temperature",
                    value20: "(20) Grid disconnection after over-voltage ride through",
                    value21: "(21) Grid disconnection after under-voltage ride through",
                    value22: "(22) Over-voltage protection on LV auxiliary power supply",
                    value23: "(23) Under-voltage protection on LV auxiliary power supply",
                    value24: "(24) Emergency shutdown input triggered",
                    value25: "(25) No reception of master heartbeat frame for more than timeout period",
                    value26: "(26) Communication loss between PFC and DCDC",
                    value27: "(27) Communication errors between PFC and DCDC",
                    value28: "(28) No charge permission input (only in DC voltage control mode)",
                    value29: "(29) No valid address selected",
                    value30:
                        "(30) DC-link bus pre-charge not completed during allowed time or voltage drops below the passive pre-charge maximum voltage",
                    value31: "(31) Regulation loss of battery voltage (only in DC voltage control mode)",
                },
            },
            connections: {
                title: "Externe Anbindungen",
                isLoading: "Loading…",
                noData: "Fehler beim Laden…",

                networkControlCenter: "Netzleitstelle",
                trading: "Vermarktung",
                monitoring: "Monitoring",

                installedInverters: "installierte Wechselrichter",
                activeInverters: "aktive Wechselrichter",

                inverters1: "{{current}} von {{max}}",
                inverters2: "Wechselrichter",
            },
            auxData: {
                title: "Nebenantriebe",
                isLoading: "Loading…",
                noData: "Fehler beim Laden…",

                fuses: "Sicherungen",
                smoke: "Brandmelder",
                doors: "Türen",
                transformer: "Trafo",
                warnings: "Warnungen",
                alarm: "Alarm",
                climate: "Klima",
                kpis: "KPIs",
                emergencyStop: "Not-Aus",
                location: "Ort",

                usv: "USV (Unterbrechnungsfreie Stromversorgung)"
            },
            sld: {
                title: "Single Line Diagram",
                isLoading: "Loading…",
                noData: "Fehler beim Laden der SLD-Daten.",
                headline: "Einliniendiagramm",

                fuses: "Sicherungen",
                smoke: "Brandmelder",
                doors: "Türen",
                transformer: "Trafo",
                climate: "Klima",
                kpis: "KPIs",
                emergencyStop: "Not-Aus",
                location: "Ort",
            },

            controlData: {
                title:"Regler",
            },

            list: {
                columns: {
                    name: "Name",
                    lastOnline: "zuletzt Online",
                    soc: "SoC",
                    totalpower: "Leistung",
                    location: "Standort",
                    condition: "Zustand",
                    deviceType: "Gerätetyp",
                },

                filter: {
                    devices: "Geräte",
                    location: "Standort",
                    name: "Name",
                },

                noItemsFound: "keine Geräte gefunden",
                loadingItems: "Daten werden geladen...",
            },

            events: {
                title: "Ereignisse",

                clearFilter: "Filter zurücksetzen",

                confirm: "Bestätigen",
                "confirmHelp": "Durch das Bestätigen wird das Event geschlossen und nicht mehr in der Liste der aktiven Events angezeigt. \n\nWichtig: Auch wenn die auslösende Bedingung weiterhin erfüllt bleiben, bleibt das bestätigte Event geschlossen. \n\nEs wird kein neues Event erzeugt, solange dieser Zustand unverändert besteht. \n\nErst wenn die Rücksetzbedingung erfüllt wurde und die auslösende Bedingung erneut eintreten, wird ein neues Event erzeugt und als aktiv angezeigt.",

                requestConfirmOkayText: "Event erfolgreich bestätigt.",
                requestConfirmErrorText: "Fehler beim bestätigen des Events.",

                requestConfirmErrorAlreadyText: "Das Event wurde bereits bestätigt.",
                requestConfirmErrorNotFoundText: "Das Event wurde nicht mehr gefunden.",
                requestConfirmErrorUnknownText: "Es gab beim bestätigen des Events einen unbekannten Fehler.",

                ignored: "zeige ignorierte Events an",
                ignoredYes: "Ja",

                acknowledge: "Nur unbestätigte Events",
                acknowledgeYes: "Ja",

                active: "Nur anstehende Events",
                activeYes: "Ja",

                toDate: "bis",
                fromDate: "von",

                state: "Zustand",

                eventType: "Status",
                id: "Id",
                eventId: "Id",
                eventTypes: "Typen",
                createdDate: "Gekommen",
                updatedDate: "Gegangen",

                isActive: "Anstehend",
                Gone: "Gegangen",
                isIgnored: "Ignoriert",
                isAcknowledged: "Bestätigt",

                message: "Nachricht",
                search: "Suche...",
                value: "Wert",
                noItemsFound: "keine Ereignisse gefunden.",

                types: {
                    unknown: "-",
                    warn: "Warnung",
                    info: "Information",
                    error: "Fehler",
                },
            },
        },

        topicBilling: {
            title: "Abrechnung-Topics",
            commonName: "Name",
            datasourceId: "ID",
            month: "Abrechnungsdatum",
            sum: "Anzahl an Topics",
            lastOnlineDate: "zuletzt Online",
            commissioningDate: "Inbetriebnahme",
            isArchived: "Archiviert",
            isDeleted: "Gelöscht",
            status:"Status",
            firstDataReceived: "Erste Übertragung",
            noItemsFound: "keine Ereignisse gefunden.",
            filter: {
                search: "Suche",
                isDeleted: "Gelöscht",
                isArchived: "Archiviert",

                name: "Name",
                deviceType: "Gerätetypen",
                lastonline: "zuletzt Online",
                commissioning:"Inbetriebnahme",
                sum: "Anzahl an Topics",
                month: "Abrechnungsdatum",

                firstReceived: "Erste Übertragung",

                showOnlyDataReceivedDevices: "Nur aktive Geräte anzeigen",
                showOnlyDataReceivedDevicesTooltip: "Zeigt nur Geräte an, die nach ihrer Inbetriebnahme mindestens einmal Daten gesendet haben.",

                ascending: "Aufsteigend",
                descending: "Absteigend",

                clearFilter: "Filter zurücksetzen",
            }
        },

        cases: {
            title: "Störmeldungen",

            newTitle: "Neue Störmeldung anlegen",
            updateTitle: "Störmeldung bearbeiten/abschließen",
            closedTitle: "Störmeldung bearbeiten/abschließen",

            details: {
                title: "Störmeldungen",
                id: "Id",
                subject: "Überschrift",
                content: "Beschreibung",

                closed: "Abgeschlossen",

                editorUser: "Bearbeiter",
                reportedUser: "Ersteller",
                device: "Gerät",
                operation:"Einsatzbericht",
                category: "Kategorie",
                selectCategory:"Störkategorie auswählen",
                createdAt: "Erstelldatum",
                component: "Komponente",
                selectComponent:"Störkomponent auswählen",
                updatedAt: "Letzte Änderung",
                startDate: "Startdatum",
                endDate:"Enddatum",
                idWillBeGenerated: "-",

                newButton: "Störmeldung anlegen",
                updateButton: "Speichern",
                closedButton: "Speichern",
                checkButton: "Erledigt",
                reopenedButton: "Speichern",
                duplicateButton: "Duplizieren",
               
                trueAddNewCaseText: "Störmeldung erfolgreich angelegt.",
                falseAddNewCaseText: "Störmeldung konnte nicht angelegt werden.",
                exceptionAddNewCaseText:
                    "Etwas ist beim Erstellen des Störmeldung schief gelaufen, versuchen Sie es später nochmal.",

                trueUpdateCaseText: "Störmeldung erfolgreich gespeichert.",
                falseUpdateCaseText: "Störmeldung konnte nicht gespeichert werden.",
                exceptionUpdateCaseText:
                    "Etwas ist beim Speichern des Störmeldung schief gelaufen, versuchen Sie es später nochmal.",

                trueClosedCaseText: "Störmeldung erfolgreich abgeschlossen.",
                falseClosedCaseText: "Störmeldung konnte nicht abgeschlossen werden.",
                exceptionClosedCaseText:
                    "Etwas ist beim Abschließen des Störmeldung schief gelaufen, versuchen Sie es später nochmal.",

                validation: {
                    user: "Es wurde kein gültiger Editor-Benutzer ausgewählt.",
                    reportedUser: "Es wurde kein gültiger Report-Benutzer ausgewählt.",
                    device: "Es wurde kein gültiges Gerät ausgewählt.",
                    subject: "Es wurde keine Überschrift angegeben.",
                    content: "Es wurde kein Störmeldungstext angegeben",
                },
            },
            list: {
                id: "Id",

                filter: {
                    search: "Suche...",
                    toDate: "bis",
                    fromDate: "von",

                    users: "Ersteller / Bearbeiter",
                    devices: "Geräte",

                    closed: "Nur abgeschlossene Störmeldungen",

                    closedYes: "Ja",
                    category: "Kategorie",
                    component:"Komponente"
                },

                subject: "Überschrift",
                content: "Beschreibung",

                name: "Name",

                lastUser: "Ersteller",

                closed: "Zustand",

                closedDate: "Abschlussdatum",
                lastEditor: "Bearbeiter",
                createDate: "Startdatum",
                endDate:"Enddatum",
                category: "Kategorie",
                component:"Komponente",
                newButton: "neue Störmeldung anlegen",
                updateButton: "Bearbeiten...",
                closedButton: "Bearbeiten / Abschließen",

                noItemsFound: "keine Störmeldungen gefunden.",
            },
        },

        reports: {
            operations: {
                title: "Einsatzberichte",

                newTitle: "Neuen Einsatzbericht anlegen",
                updateTitle: "Einsatzbericht bearbeiten",
                closedTitle: "Einsatzbericht bearbeiten",

                details: {
                    title: "Einsatzberichte",
                    id: "Id",
                    description: "Störbeschreibung",
                    troubleshooting: "Störbehebung",
                    replacedEquipments: "Geräteaustausch, wenn ja spezifizieren",
                    pendingDescription: "Beschreibung der ausstehenden Arbeiten",

                    creatorUser: "Ersteller",
                    createdAt: "Erstelldatum",
                    closed: "Abgeschlossen",
                    editorUser: "Bearbeiter",
                    device: "Gerät",
                    cases:"Störmeldungen zuordnen",
                    serialnumber: "Seriennummer",
                    updatedAt: "letzte Änderung",
                    ratedCapacity: "Nennkapazität",
                    startingUp: "Inbetriebnahme",
                    charging: "EV-Charging",
                    lastMintenance: "Letzte Wartung",
                    idWillBeGenerated: "-",
                    newButton: "Einsatzbericht anlegen",
                    updateButton: "Speichern",
                    checkButton: "Archiviert",
                    serviceDate:"Einsatzdatum",
                    reopenedButton: "Speichern",
                    trueAddNewOperationText: "Einsatzbericht erfolgreich angelegt.",
                    falseAddNewOperationText: "Einsatzbericht konnte nicht angelegt werden.",
                    exceptionAddNewOperationText:
                        "Etwas ist beim Erstellen des Störmeldung schief gelaufen, versuchen Sie es später nochmal.",

                    trueUpdateOperationText: "Einsatzbericht erfolgreich gespeichert.",
                    falseUpdateOperationText: "Einsatzbericht konnte nicht gespeichert werden.",
                    exceptionUpdateOperationText:
                        "Etwas ist beim Speichern des Einsatzbericht schief gelaufen, versuchen Sie es später nochmal.",

                    trueClosedOperationText: "Einsatzbericht erfolgreich abgeschlossen.",
                    falseClosedOperationText: "Einsatzbericht konnte nicht abgeschlossen werden.",
                    exceptionClosedOperationText:
                        "Etwas ist beim Abschließen des Störmeldung schief gelaufen, versuchen Sie es später nochmal.",

                    validation: {
                        creatorName: "Es wurde kein gültiger Editor-Benutzer ausgewählt.",
                        reporterName: "Es wurde kein gültiger Report-Benutzer ausgewählt.",
                        device: "Es wurde kein gültiges Gerät ausgewählt.",
                        description: "Es wurde keine Störbeschreibung angegeben.",
                        troubleshooting: "Es wurde keine Störbehebung angegeben",
                        isEquipmentReplaced: "Geräteaustausch, wenn ja spezifizieren",
                        isElectricalPlanUpdateNecessary: "Geräteaustausch, wenn ja spezifizieren",
                        isTroubleshootingFinished: "Geräteaustausch, wenn ja spezifizieren",
                        pendingDescription: "Es wurde keine Beschreibung für ausstehende Arbeiten angegeben",
                        replacedEquipments: "Es wurde kein Text für den Geräteaustausch angegeben",
                    },
                },
                list: {
                    id: "Id",

                    filter: {
                        search: "Suche...",
                        toDate: "bis",
                        fromDate: "von",

                        users: "Ersteller / Bearbeiter",
                        devices: "Geräte",

                        archiviert: "Nur Archivierte anzeigen",

                        electricalPlan: "Elektroplan aktualisieren ",

                        störbehebung: "Störbehebung vorhanden",

                        geräteaustausch: "Geräteaustausch vorhanden",
                  
                        ausstehendarbeiten: "ausstehende Arbeiten vorhanden ",
                        
                    },

                    description: "Störbeschreibung",
                    troubleshooting: "Störbehebung",
                    name: "Name",
                    deviceId: "Name",
                    serialnumber: "Seriennummer",
                    creator: "Ersteller",
                    closed: "Status",
                    closedDate: "Abschlussdatum",
                    lastEditor: "Bearbeiter",
                    createdAt: "Erstelldatum",
                    updatedDate: "Änderungsdatum",
                    serviceDate: "Einsatzdatum",
                    isArchived: "Archiviert",
                    editor: "Bearbeiter",

                    newButton: "neuen Einsatzbericht anlegen",
                    updateButton: "Bearbeiten...",

                    noItemsFound: "keine Einsatzberichte gefunden.",
                },
            },
            monthlyReports: {
                title: "Monatsberichte",
                title2:"Bericht",
                tableName: "Zusammenfassung",
                deviceName: "Gerät",

                dailyOverview: "Übersicht der täglichen Ladung und Entladung",
                selectFilterPrompt: "Bitte wählen Sie das Gerät, das Jahr und den Monat aus, um Ihre Daten anzuzeigen.",
                january: "Januar",
                february: "Februar",
                march: "März",
                april: "April",
                may: "Mai",
                june: "Juni",
                july: "Juli",
                august: "August",
                september: "September",
                october: "Oktober",
                november: "November",
                december: "Dezember",

                summary: {
                    totalBatteryToGrid: "Gesamtenergie, geliefert",
                    totalGridToBattery: "Gesamtenergie, bezogen",
                    batteryToGrid: "Energie, geliefert",
                    gridToBattery: "Energie, bezogen",
                    roundTripEfficiency: "Wirkungsgrad gesamt  (RTE)",
                    equivalentFullCycles: "Äquivalente Vollzyklen (EFC)",
                    technicalAvailability: "Technische Verfügbarkeit",
                },
                gridToBattery: "Netz zu Batterie (Lade-/Importenergie)",
                BatteryTogrid: "Batterie zu Netz (Entlade-/Exportenergie)",
                sections: {
                    events: "Ereignisse",
                    operations: "Einsatzberichte",
                    cases: "Störmeldungen",
                },
                noOperations: "Keine Einsatzberichte für diesen Zeitraum.",
                noCases: "Keine Störmeldungen für diesen Zeitraum.",
                noEvents: "Keine Ereignisse für diesen Zeitraum.",
            },
        },
        favorites: {
            title: "Favoriten",
            name:"Name",
            id: "ID",
            delete: "Löschen",
            addToFavorite: "Zu Favoriten hinzugefügt",
            removeFromFavorite: "Aus Favoriten entfernt",
            noItemsFound:"keine Favoriten gefunden."
        },

        user: {
            notifications: {
                title: "E-Mail",

                deviceAlarmTitle: "Geräte Alarme",
                deviceAlarmText:
                    "Benachrichtigung wenn ein Fehler bei einem Gerät auftritt. Dies betrifft alle Geräte die dem Benutzer zugeordnet sind.",

                deviceAlarmInfoText: "Der E-Mail-Versand findet täglich gegen 8 Uhr (MEZ) statt.",

                okayDeviceAlarmText: "Benachrichtigung gespeichert.",
                failedDeviceAlarmText: "Benachrichtigung konnte nicht gespeichert werden.",
                errorDeviceAlarmText: "Etwas ist beim speichern schief gelaufen, versuchen Sie es später nochmal.",

                createTestMailTitle: "Testnachricht",
                createTestMailText:
                    "Mit dieser Funktion können Sie eine Testnachricht versenden, um sicherzustellen, dass das Benachrichtigungssystem ordnungsgemäß funktioniert und Sie über wichtige Ereignisse zuverlässig informiert werden.",

                createTestMailButtonText: "sende Testnachricht",

                okayTestMailText: "Testnachricht wird erstellt.",
                failedTestMailText: "Testnachricht konnte nicht erstellt werden.",
                errorTestMailText:
                    "Etwas ist beim erstellen der Testnachricht schief gelaufen, versuchen Sie es später nochmal.",
            },
            account: {
                common: {
                    title: "Allgemein",
                    fullName: "Name",
                    userName: "Benutzername",
                    mailAddress: "E-Mail",

                    mailContactText: "Bitte Kontaktieren Sie uns um Ihre E-Mail zu ändern",

                    userLevel: "Rolle",
                },

                theme: {
                    title: "Anzeige",

                    lightTitle: "Helles Design",
                    darkTitle: "Dunkles Design",

                    lightText: "Am besten für helle Umgebungen",
                    darkText: "Empfohlen für dunkle Räume",

                    okayThemeSettingsText: "Anzeige gespeichert.",
                    failedThemeSettingsText: "Anzeige konnte nicht gespeichert werden.",
                    errorThemeSettingsText: "Etwas ist beim speichern schief gelaufen, versuchen Sie es später nochmal.",
                },

                avatar: {
                    okayUploadText: "Avatar hochgeladen.",
                    failedUploadText: "Beim Hochladen des Avatars ist ein Fehler aufgetreten.",
                    execeptionUploadText: "Leider ist beim Hochladen etwas schiefgelaufen. Bitte versuchen Sie es später noch einmal.",
                    execeptionInvalidImageText: "Leider ist beim Öffnen des Bildes etwas schiefgelaufen. Bitte versuchen Sie es später noch einmal.",
                    toolargeImageText: "Das Bild überschreitet die maximale Größe von 65 KB. Bitte verkleinern Sie das Bild oder wählen Sie ein anderes aus."
                },

                password: {
                    title: "Passwort ändern",

                    mailAddress: "E-Mail zum Passwort zurücksetzen",

                    resetPasswortButtonText: "Passwort zurücksetzen",

                    okayResetMailText: "Passwort Aufforderung wurde versendet.",
                    failedResetMailText: "Passwort Aufforderung konnte nicht gesendet werden!",
                    errorResetMailText:
                        "Etwas ist beim senden der Passwort Aufforderung schief gelaufen, versuchen Sie es später nochmal.",
                },
            },
        },
    },
    components: {
        summary: {
            increase: "Zunahme",
            decrease: "Abnahme",
        },
        deviceHexa: {
            title: "Geräte Übersicht",
        },
        deviceWorldmap: {
            title: "Geräte Weltkarte",

            deviceType: "Gerätetyp",
            deviceLocation: "Standort",
            deviceId: "Name",

            deviceStatus: "Status",

            mapStatus: {
                offline: "Offline",
                online: "Online",
                warn: "mindestens eine Warnung vorhanden",
                error: "mindestens ein Fehler vorhanden",
            },
        },
        devicesTable: {
            states: {
                online: "Online",
                offline: "Offline",
                unknown: "Unbekannt",

                today: "Heute",
                yesterday: "Gestern",
                beforeYesterday: "Vorgestern",
                longTimeAgo: "Vor langer Zeit",
            },
            conditions: {
                error: "Fehler",
                warn: "Warnung",
                service: "Wartungsmodus",
                off: "Ausgeschaltet",
                on: "Eingeschaltet",
                running: "In Betrieb",
                unknown: "Unbekannt",

                vehicle: {
                    standby: "Auto in Bereitschaft",
                    loading: "Auto lädt...",
                    error: "Fehler beim laden",
                },
                wallbox: {
                    available: "Ladestation verfügbar",
                    occupied: "Ladestation besetzt",
                    loading: "Ladestation lädt...",
                    error: "Fehler in der Ladestation",
                },
            },
            tabs: {
                all: "Alle",
                offline: "Offline",
                online: "Online",
            },
            sorting: {
                sortBy: "Sortierung",
                order: "Reihenfolge",

                Ascending: "Aufsteigend",
                Descending: "Absteigend",
            },
            sortingValue: {
                sortBy: "Sortieren nach",

                online: "Online",
                location: "Standort",
                soc: "SoC",
                power: "Leistung",
                name: "Name",
            },
            filters: {
                byName: "nach Namen filtern",
                byStatus: "nach Status filtern",
            },
            apply: "Übernehmen",
        },
        eventsTable: {
            sorting: {
                sortBy: "Sortierung",
                order: "Reihenfolge",
                Ascending: "Aufsteigend",
                Descending: "Absteigend",
            },
            sortingValue: {
                sortBy: "Sortieren nach",

                Id: "Id",
                CreatedAt: "Gekommen",
                ClearedAt: "Gegangen",
            },
        },
        casesTable: {
            sorting: {
                sortBy: "Sortierung",
                order: "Reihenfolge",
                Ascending: "Aufsteigend",
                Descending: "Absteigend",
            },
            sortingValue: {
                sortBy: "Sortieren nach",
                Id: "Id",
                Device: "Name",
                Creator: "Ersteller",
                Reporter: "Reporter",
                CreatedAt: "Erstelldatum",
                Component: "Komponente",
                Category:"Kategorie",
            },
        },
        operationsTable: {
            states: {
                updateElectricalPlan: "Elektroplan aktualisieren",
                troubleshootingDone: "Störbehebung vorhanden",
                equipmentReplaced: "Geräteaustausch vorhanden",
                pendingWork: "Ausstehende Arbeiten vorhanden",
                isTroubleshootingFinished: "Das System wurde nach Abschluss der Arbeiten nicht in einem ordnungsgemäßen, funktionsfähigen oder sauberen Zustand hinterlassen."
            },
            sorting: {
                sortBy: "Sortierung",
                order: "Reihenfolge",
                Ascending: "Aufsteigend",
                Descending: "Absteigend",
            },
            sortingValue: {
                sortBy: "Sortieren nach",
                Id: "Id",
                Device: "Name",
                Creator: "Ersteller",
                Reporter: "Reporter",
                CreatedAt: "Erstelldatum",
            },
        },
    },
} as const;
